var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7D925618-2029-48E1-8B95-28A2D48D9D1F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main-page-Full",
    transform: "translate(-90, -1264)",
    fill: "#256BFD"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Audience-Copy",
    transform: "translate(24, 1189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Secret-Fans",
    transform: "translate(0, 43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/icons_24/Likes",
    transform: "translate(66, 32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.5, 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4763447,0.00778869923 C14.1307733,0.0802814658 12.898725,0.655986648 11.7292012,1.61626962 L11.4885,1.82014692 L11.2444369,1.61307064 C9.99421186,0.582851637 8.68743971,0 7.23356494,0 C5.26215441,0 3.45738539,0.653011359 2.14414289,1.89021418 C0.758478268,3.19564571 0,5.082564 0,7.28277124 C0,9.5158228 1.26888932,11.5580678 3.73063114,13.9323838 C4.13093776,14.3184742 4.5650479,14.7145858 5.04475572,15.133343 L6.28450799,16.1872834 C6.64156053,16.481902 7.11107904,16.8612547 8.01222286,17.5867195 L9.61285288,18.8790321 C9.96601929,19.1669674 10.2729013,19.4204417 10.5769734,19.6755527 C11.1105991,20.1059312 11.8649742,20.1058976 12.3827355,19.688806 L13.3608157,18.8802905 L16.7570651,16.1278045 C17.3142493,15.6685112 17.653502,15.3753019 18.1535004,14.933928 C18.5445361,14.5887411 18.9058969,14.2576105 19.2428812,13.9345906 C21.733667,11.5470218 23,9.53056132 23,7.28281372 C23,5.07596056 22.2291745,3.19904719 20.8294418,1.88807286 C19.5103474,0.652659822 17.7253541,0 15.7664376,0 L15.4763447,0.00778869923 Z M15.8076592,2 C17.2704408,2 18.5560253,2.47761928 19.4817931,3.35860591 C20.4547591,4.28453493 21,5.63352104 21,7.31149736 C21,8.8672547 19.9943775,10.4943302 17.8621001,12.5711277 C17.6499321,12.7777753 17.4264549,12.9888852 17.1902194,13.2060689 L16.3767929,13.9367593 C15.9795938,14.2869814 15.6082128,14.6026341 14.9580991,15.1403821 L12.0476803,17.5328858 L11.4873333,18 L10.2141726,16.945647 L7.53461238,14.7442916 C7.25397302,14.5084961 7.04005426,14.3233208 6.72197777,14.046608 C6.11661025,13.5199645 5.58839533,13.0365449 5.11585624,12.5734555 C3.00958488,10.5093054 2,8.85826434 2,7.31145378 C2,5.63388409 2.53821781,4.27338282 3.49606326,3.35648203 C4.41246929,2.47924926 5.71603044,2 7.19234334,2 C8.36510834,2 9.52427832,2.68601737 10.7341983,3.94815249 L11.4884533,4.734958 L12.2420232,3.94746554 C13.4426324,2.69280981 14.623859,2 15.8076592,2 Z",
    id: "Like"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikes);
export default __webpack_public_path__ + "static/media/likes.7807167cee36ac78717ea6c937d84445.svg";
export { ForwardRef as ReactComponent };